"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
exports.MediaStreamTypes = types_1.MediaStreamTypes;
var vidi_1 = require("./vidi");
exports.Vidi = vidi_1.Vidi;
exports.default = vidi_1.Vidi;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/index.js
// module id = 376
// module chunks = 0 1 2 3